import { HUD } from '../../config/tuning';
import type { HudPainter } from '../HudLayout';
import { TextSlot } from '../HudLayout';
import type { HudFrame } from '../HudFrame';

/**
 * The mission-start control hold countdown.
 *
 * Held controls that say nothing are indistinguishable from broken controls, and the player's
 * first act on a dead stick is to press harder — which is exactly the input the hold exists to
 * discard. So the display states the condition and counts it out.
 *
 * High on the display rather than by the reticle: see `HUD.startHoldTopPx` for why the middle and
 * the low centre are both already spoken for during the five seconds this element is up.
 */
export function drawStartHold(painter: HudPainter, frame: HudFrame): void {
  if (frame.controlLockS <= 0) return;

  const layout = painter.layout;
  const y = layout.px(HUD.startHoldTopPx);
  const line = layout.fontPx * 1.4;

  painter.text('CONTROLS HELD', layout.centreX, y, 'centre');
  // Whole seconds, rounded up, so the last visible number is 1 rather than 0 — a displayed zero
  // beside a stick that still does nothing is the confusion this element exists to prevent.
  painter.text(
    painter.number(TextSlot.ControlLock, Math.ceil(frame.controlLockS), 0),
    layout.centreX,
    y + line,
    'centre',
  );
}
